import React, { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import ThermalReceipt from "../../../../Components/GeneralComponents/ThermalReceipt";

const money = (value) => `${Number(value || 0).toFixed(0)} AFN`;

const Print = forwardRef(({ data }, ref) => {
  const { t } = useTranslation();

  return (
    <ThermalReceipt
      ref={ref}
      clinicName={t("print.turkishClinic")}
      phone={`${t("print.phone")}: ${t("print.phoneNumber")}`}
      address={t("print.address")}
      note={t("finance.payroll", "Payroll")}
      rows={[
        { label: `${t("hr.employee")}:`, value: data?.employee_display || "-" },
        { label: `${t("hr.month")}:`, value: data?.month_display || "-" },
        { label: `${t("hr.year")}:`, value: data?.year || "-" },
      ]}
      totals={[
        { label: t("hr.totalSalary"), value: money(data?.total_salary), bold: true },
        { label: t("hr.advanceAmount"), value: money(data?.total_advance) },
        { label: t("hr.paidSalary"), value: money(data?.paid_salary) },
        { label: t("hr.remainingSalary"), value: money(data?.remaining_salary), color: "#0f766e" },
      ]}
      footerLines={[t("print.cosmos")]}
    />
  );
});

export default Print;
